const FILTER_MY_CONVERSATIONS = 'My Conversations';
const FILTER_UNASSIGNED = 'Unassigned';
const FILTER_OPEN = 'Open';
const FILTER_CLOSED = 'Closed';
const FILTER_SENT = 'Sent';
const FILTER_ASSIGNED_TO_BOT = 'Assigned to Bot';
const FILTER_CONTACT_OPEN = 'Contact Open';
const FILTER_CONTACT = 'Contact';
const FILTER_CUSTOM_FILTER = 'Custom Filter';
const FILTER_TAG = 'Tag';
const FILTER_UNDELIVERED = 'Undelivered';

const FILTERS_SHOWING_UNREAD_MESSAGES = [
  FILTER_MY_CONVERSATIONS,
  FILTER_UNASSIGNED,
  FILTER_CUSTOM_FILTER,
];

export {
  FILTER_MY_CONVERSATIONS,
  FILTER_UNASSIGNED,
  FILTER_OPEN,
  FILTER_CLOSED,
  FILTER_SENT,
  FILTER_ASSIGNED_TO_BOT,
  FILTER_CONTACT_OPEN,
  FILTER_CONTACT,
  FILTER_CUSTOM_FILTER,
  FILTER_TAG,
  FILTER_UNDELIVERED,
  FILTERS_SHOWING_UNREAD_MESSAGES,
};
